"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var Index_1 = require("../../../components/base/Index");
var styles = require("../../../styles/ModelResultStyles");
var TestIds_1 = require("../../../util/TestIds");
var Utils_1 = require("../../../util/Utils");
var Analyses_1 = require("../type/Analyses");
var CONTAINER_WIDTH = 500;
var CHART_WIDTH = 436;
var CHART_HEIGHT = 365;
var ModelResultOutcomeDistribution = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (root) { return root.modelResult; }), modelOutcomeDistribution = _a.modelOutcomeDistribution, modelOutcome = _a.modelOutcome, modelFields = _a.modelFields, type = _a.type;
    if (!modelOutcomeDistribution || !modelOutcome || !modelFields) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'outcome-distribution' });
    }
    var metricTitle = Localize_1.Messages.modelResultOutcomeDistributionTitle();
    var yAxisLabel = Localize_1.Messages.countLabel();
    var outcomeName = modelOutcome === null || modelOutcome === void 0 ? void 0 : modelOutcome.name;
    var outcomeText = modelOutcome.label;
    var outcomeField = modelFields.find(function (n) { return n.name === outcomeName; });
    var tooltip = Localize_1.Messages.modelResultOutcomeDistributionDescription({ outcomeText: outcomeText });
    var barColor = (0, Utils_1.isBinomialModel)(type) ? prediction_model_results_viz_1.VizColors.background02 : undefined;
    var renderChart = function () {
        if ((outcomeField === null || outcomeField === void 0 ? void 0 : outcomeField.type) === Analyses_1.FieldColumnType.Number) {
            var xAxisLabel = Localize_1.Messages.rangeLabel();
            return (React.createElement(prediction_model_results_viz_1.HistogramComponent, { bins: modelOutcomeDistribution, yAxisLabel: yAxisLabel, xAxisLabel: xAxisLabel, width: CHART_WIDTH, height: CHART_HEIGHT, color: barColor }));
        }
        else if ((outcomeField === null || outcomeField === void 0 ? void 0 : outcomeField.type) === Analyses_1.FieldColumnType.Text) {
            return (React.createElement(prediction_model_results_viz_1.BarChartComponent, { data: modelOutcomeDistribution.map(function (props) { return (__assign(__assign({}, props), { color: barColor })); }), xAxisLabel: outcomeText, yAxisLabel: yAxisLabel, width: CHART_WIDTH, height: CHART_HEIGHT }));
        }
        return null;
    };
    return (React.createElement(Index_1.Card.Container, { header: metricTitle, tooltip: tooltip, width: CONTAINER_WIDTH },
        React.createElement("div", { className: styles.OverviewDataDistribution }, renderChart())));
};
exports.default = ModelResultOutcomeDistribution;
//# sourceMappingURL=ModelResultOutcomeDistribution.js.map